<template>
    <footer class=" footstyle">
       <!-- <cookie-law theme="dark-lime"></cookie-law> -->
        <div class="w-100">
            <router-link :to="{ name: 'Home'}">
            <img class="logo" src="/img/logo-enterprise.png"/>
            </router-link>
        </div>
        <br><br>
        <!-- 1st footer -->
        <b-container fluid class=" col-12 ">
        <b-row>
          <!-- column 1 -->  
          <b-col md="3">
            <div class="colml text-white">
             <p class="navfont text-uppercase">{{$t('footer_label.reservations')}}</p>
             <div class="mt-2"><router-link class="textmenu" :to="{ name: 'Home'}"> <a class="textmenu text-capitalize" href="">{{$t('footer_label.make_reserve')}}</a></router-link><br> </div>
             
             <div class="mt-2"><router-link class="textmenu" :to="{ name: 'RentTerms'}"><a class="textmenu text-capitalize" href="">{{$t('footer_label.conditions')}}</a></router-link></div> 
             <!-- <div class="mt-2"> <a class="textmenu" href="">Ver/Modificar/Cancelar</a><br> </div>
              -->
             <br><br>
            </div>
          </b-col>
          <!-- column 2 --> 
          <b-col md="3">
              <p class="colml navfont text-uppercase">{{$t('footer_label.vehicles')}} </p>
             <div class="colml mt-2"> <router-link class="textmenu" :to="{ name: 'Fleet'}"><a class="textmenu text-capitalize">{{$t('footer_label.see_fleet')}}</a></router-link></div> 
             <!-- <div class="colml mt-2"> <a class="textmenu" href="">SUV´s</a></div> 
             <div class="colml mt-2"> <a class="textmenu" href="">Van</a></div> 
             <div class="colml mt-2"> <a class="textmenu" href="">Comercial</a></div> -->
              <br><br>
          </b-col>
          <!-- column 3 --> 
          <b-col md="3">
              <p class="colml navfont text-uppercase">{{$t('footer_label.promotions')}}</p>
              <!--<div class="colml mt-2"><router-link class="textmenu" :to="{ name: 'Weekend'}"    ><a class="textmenu text-capitalize" href="">{{$t('footer_label.weekend')}}</a></router-link></div>
              <div class="colml mt-2"><router-link class="textmenu" :to="{ name: 'Greenweek'}"  ><a class="textmenu text-capitalize" href="">{{$t('footer_label.green_week')}}</a></router-link></div>
              <div class="colml mt-2"><router-link class="textmenu" :to="{ name: 'Twoonefree'}" ><a class="textmenu text-capitalize" href="">{{$t('footer_label.twoonefree')}}</a></router-link></div>
              <div class="colml mt-2"><router-link class="textmenu" :to="{ name: 'Pack3d'}"     ><a class="textmenu text-capitalize" href="">{{$t('footer_label.3days')}}</a></router-link></div>
              <div class="colml mt-2"><router-link class="textmenu" :to="{ name: 'Pack4d'}"     ><a class="textmenu text-capitalize" href="">{{$t('footer_label.4days')}}</a></router-link></div>-->
              <div class="colml mt-2"><router-link class="textmenu" :to="{ name: 'Bymonth'}"    ><a class="textmenu text-capitalize" href="">{{$t('footer_label.monthly_rent')}}</a></router-link></div>
              <br><br>
          </b-col>
          <!-- column 4 --> 
          <b-col md="3">
              <p class="colml navfont text-uppercase">{{$t('footer_label.business')}}</p>
              <div class="colml mt-2">
                <router-link :to="{ name: 'Leasing'}" class="textmenu">
                  <a class="textmenu text-capitalize" href="">{{$t('footer_label.leasing_ope')}}</a>
                </router-link>  
              </div>
              <div class="colml mt-2">
                <router-link :to="{ name: 'Contact'}" class="textmenu">
                  <a class="textmenu text-capitalize" href="">{{$t('footer_label.contact')}}</a>
                </router-link>
              </div>
              <br><br>
          </b-col>
        </b-row>
        </b-container>
        <!--  -->
        <br>
        <div class="foot2 w-100 mb-3">
          <br>
          <div class="ml-5 mr-5">
            <router-link :to="{ name: 'Terms'}" class="textfoot2">
            <a class="textfoot2" href="">{{$t('footer_label.terms')}}</a>
            </router-link> | 
            <router-link :to="{ name: 'Privacy'}">
            <a class="textfoot2" href="">{{$t('footer_label.policies')}}</a>
            </router-link> | 
            <router-link :to="{ name: 'Cookies'}">
            <a class="textfoot2" href="">{{$t('footer_label.cookies')}}</a>
            </router-link> | 
            <!-- <a class="textfoot2" href="">Elecciones de anuncio</a> |  -->
            © 2020 <br>
            <a class="textfoot2">Servicios Turísticos Panameños S.A.</a>
          </div>
        </div>

    </footer>
</template>

<script>
export default {
    name: 'mainfooter',
    components: {
      
    },
    data(){
      return{
        
      }
    }
}
</script>

<style lang="scss">
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
    
}
.footstyle{
    background-color: #169a5a;
    bottom: 0;
    position: relative;

}
.logo{
    height: 35px;
    width: 168px;
    border: 1px solid #fff;
    margin-left: 62px;
    margin-top: 40px;
}
.navfont{
color: #ffffff; 
font-family: 'DIN 2014-Regular', sans-serif;
font-size: 14px;
font-weight: 700;
height: 26px;
line-height: 16.3333px;
margin: 0px;
padding: 0px 0px 10px;

}
.colml{
  margin-left: 48px;
}
.textmenu{
  font-family: 'DIN 2014-Regular', sans-serif;
  color: #c6ddbf;
  text-decoration: none;
  
  font-size: 15px;
}
a.textmenu:hover {
  color: #fff;
  text-decoration: none;
  
}
.foot2{
    height: 70px;
    background-color: #fff;
}
.textfoot2{
    color: #272727; 
    font-family: 'DIN 2014-Regular', sans-serif;
    font-size: 14px;
    font-weight: 300;
}
a.textfoot2:hover {
  color: #808080;
  text-decoration: none;
}

</style>